'use strict';

const STATS = {
    VK_API_VERSION: 5.141,
    VK_ACCESS_TOKEN: '',
};

module.exports = STATS;
